export enum FieldType {
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  USER = 'USER',
  CHECKBOX = 'CHECKBOX',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
  VEHICLE = 'VEHICLE',
  VEHICLE_DEPARTMENT = 'VEHICLE_DEPARTMENT',
}
